/**
 * 「見た」に数える画面の住所か — 画面（usage-view-reporter）とサーバー（/api/usage/view）が同じ判定を使う。
 *
 * 数えない: お客様向け・ログイン画面・印刷など、ログインなしで開ける画面。
 *   🔴 middleware の公開住所だけでは足りない（/print・/intake-v3 など画面側だけで公開している住所がある・
 *   門番 2026-09-22）。画面側の一覧 CLIENT_PUBLIC_PATHS は両方を合わせた物なので、そちらを使う。
 * 受け付けない形: 住所でないもの・別サイト（'//…'）・クエリ付き・制御文字・API の住所・長すぎるもの。
 *   🔴 制御文字（NUL 等）は DB が受け付けない。ここで止めないと、書く所で黙って落ちる（同上）。
 */
import { isClientPublicPath } from '@/lib/providers/auth-provider-public-paths'

const MAX_PATH_LENGTH = 500

/** 住所として受け付けてよい形か（公開画面かどうかは見ない） */
export function isWellFormedPagePath(path: unknown): path is string {
  if (typeof path !== 'string') return false
  if (path.length === 0 || path.length > MAX_PATH_LENGTH) return false
  if (!path.startsWith('/') || path.startsWith('//')) return false
  if (/[?#\s\\]/.test(path) || hasControlChar(path)) return false
  return !(path === '/api' || path.startsWith('/api/'))
}

/** 制御文字（U+0000〜U+001F・U+007F）を含むか */
function hasControlChar(s: string): boolean {
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i)
    if (c < 0x20 || c === 0x7f) return true
  }
  return false
}

/** ログインなしで開ける画面か（middleware の公開住所＋画面側だけの公開住所・前方一致） */
export function isPublicPagePath(path: string): boolean {
  return isClientPublicPath(path)
}

export function isCountablePagePath(path: unknown): path is string {
  return isWellFormedPagePath(path) && !isPublicPagePath(path)
}
